<template>
  <f7-page :page-content="false">
    <!-- Top Navbar -->
    <f7-navbar :title="tipoLinea == 'DIA' ? 'Resumen DIA' : tipoLinea == 'SEMANA' ? 'Resumen SEMANA' : 'Resumen MES'" :back-link="$t('atras')"></f7-navbar>
    <!-- Page content-->
    <f7-page-content class="full-height">
      <!-- rList Table CARD-->
      <r-dynamic-list 
        ref="rlist"
        :dbAdapter="ListadoCalendario"
        :tableCode="'LISTADO_CALENDARIO_' + tipoLinea"
        :tableMode="true"
        :virtualListParams="{ height: 32, rowsBefore: 60, rowsAfter: 60 }"
        class="card full-height data-table"
        classContent="card-content full-height"
        :massiveActions="false"
        :mandatoryFilter ="{tipoLinea: tipoLinea}"
        :filtersNoCounters="['tipoLinea']"
        :controlsWidth="60"
        @deleteItem="reload"
        :filterColumns="filterColumns"
      >
        <template v-slot:extendedActions>
          <f7-link v-roles="['ADMINISTRATIVO','PLANIFICADOR','DTYCAL']"  v-tooltip="'Generar Resumen'" icon-f7="goforward" color="red" @click="popupCalcularResumen(tipoLinea)"></f7-link>
        </template>
        <template v-slot:optionsColumn="{ item }">
          <f7-link v-roles="['ADMINISTRATIVO','PLANIFICADOR']" v-if="tipoLinea == 'MES'" v-tooltip="'Asignar consumo real'" icon-f7="bolt_fill" color="deeppurple" @click="asignaConsumoReal(item)"></f7-link>
          <f7-link v-roles="['ADMINISTRATIVO','PLANIFICADOR','DTYCAL']" v-tooltip="'Recalcular resumen de la línea'" icon-f7="goforward" color="orange" @click="calcular(item)"></f7-link>
        </template>
        <template v-slot:tableLinks>
          <r-form
            class="form-inline display-flex"
            ref="rformImport"
            v-slot="{rform}"
            :readonly="false"
            :dbAdapter="null"
            :documentoAdapter="Documento"
            :beforeSave="beforeSaveImport"
            @save="onImport"
            @error="onImportError"
          >
            <r-files v-if="tipoLinea == 'MES'" v-roles="['ADMINISTRATIVO','PLANIFICADOR']" path="/listadoCalendario/consumos_reales/" :form="rform" name="documento" :maxFiles='1' label="Importar Documento" @loadFile="loadFile" :preview="false"></r-files>
          </r-form>
        </template>
      </r-dynamic-list>
    </f7-page-content>
    <!-- popup:closed (pasado), NO popup:close: con v-if hay que esperar a que termine la animación
         de cierre. Si se destruye el componente al empezarla, F7 deja el backdrop pegado en el DOM,
         que tapa el banner de progreso y se come los clics del icono de generar. -->
    <f7-popup class="popupcalcular" ref="popupcalcular" @popup:closed="popupCalcularShow = false" swipeToClose :opened="true" v-if="popupCalcularShow">
      <!-- Sin hidePreloaderOnSave: el job es asíncrono y quien informa de que sigue vivo es la
           barra de progreso, no un spinner bloqueante (que además impediría cerrar el modal). -->
      <r-form
        ref="formCalcular"
        @save="lanzarGeneracion"
        :defaultData="filter"
      >
        <template v-slot="{rform}">
          <f7-page v-if="filter" >
            <f7-navbar>
              <f7-nav-left></f7-nav-left>
              <f7-nav-title>
                {{$t('listadoCalendario.calcularResumen') + ' ' + tipoLinea}}
              </f7-nav-title>
              <!-- Sin botón de cerrar propio: la directiva de app.js ya inyecta maximizar y
                   cerrar en el nav-right de todos los popups. -->
              <f7-nav-right></f7-nav-right>
            </f7-navbar>
            <f7-list no-hairlines-md>
              <f7-row class="list list-form no-hairlines">
                <f7-col width="66" medium="66">
                  <r-autocomplete-m2m
                    outline
                    :dbAdapter="Empleado"
                    key="empleados"
                    class="col-100 medium-33"
                    floating-label
                    :label="$t('common.persona')"
                    :form="rform"
                    name="usernames"
                    labelProp="nombre"
                    idProp="username"
                    prefixProp="username"
                    idFieldDetail="id"
                    :showNavigationLink="false"
                    type="textarea"
                    :lineBreak="true"
                  ></r-autocomplete-m2m>
                </f7-col>
                <f7-col width="66" medium="66">
                  <r-input floating-label :label="$t('anio')" :form="rform" type="select" name="anio" :clearButton="false" outline>
                    <option v-for="i in 4" :value="filter.anio - 5 + i" :key="'anio-'+(filter.anio - 5 + i)">{{filter.anio - 5 + i}}</option>
                    <option :key="'anio-'+filter.anio" selected="true" :value="filter.anio">{{filter.anio}}</option>
                    <option :key="'anio-'+(filter.anio+1)" :value="filter.anio+1">{{filter.anio+1}}</option>
                  </r-input>
                </f7-col>
                <f7-col width="66" medium="66">
                  <r-autocomplete-m2m
                    outline
                    class="col-100"
                    floating-label
                    :label="$t('mes')"
                    :dbItems="getMeses()"
                    :form="rform"
                    name="meses"
                    type="textarea"
                    :lineBreak="true"
                    idProp="id"
                    labelProp="nombre"
                  ></r-autocomplete-m2m>
                </f7-col>
                <f7-col v-if="['SEMANA','DIA'].includes(tipoLinea)" width="66" medium="66">
                  <r-input floating-label :label="$t('semana')" :form="rform" type="number" name="semana" :clearButton="false" outline></r-input>
                </f7-col>
                <f7-col v-if="tipoLinea == 'DIA'" width="66" medium="66">
                  <r-input floating-label :label="$t('dia')" :form="rform" type="number" name="dia" :clearButton="false" outline></r-input>
                </f7-col>
              </f7-row>
            </f7-list>
            <div v-if="generacion" class="margin-horizontal generacion-panel">
              <div class="generacion-texto">{{generacion.texto}}</div>
              <f7-progressbar
                v-if="generacion.total > 0"
                :progress="progresoPorcentaje"
              ></f7-progressbar>
              <div class="generacion-detalle">
                <span v-if="generacion.total > 0">{{generacion.hechos}} / {{generacion.total}} empleados</span>
                <span v-if="generacion.guardados"> · {{generacion.guardados}} resúmenes guardados</span>
                <span v-if="generacion.restanteTexto"> · quedan ~{{generacion.restanteTexto}}</span>
              </div>
              <div v-if="generacion.numErrores" class="generacion-detalle generacion-error">
                {{generacion.numErrores}} empleado(s) con error
              </div>
              <ul v-if="generacion.errores && generacion.errores.length" class="generacion-errores">
                <li v-for="(e, i) in generacion.errores" :key="'err-'+i">{{e}}</li>
              </ul>
              <div v-if="generacionEnCurso" class="generacion-detalle">
                Puedes cerrar esta ventana: el proceso sigue guardando y te avisamos al terminar.
              </div>
            </div>
            <f7-button
              v-if="!generacionEnCurso"
              fill
              color="primary"
              class="margin-horizontal"
              @click="$refs.formCalcular.saveItem()"
            >{{$t('listadoCalendario.calcularResumen')}}</f7-button>
            <f7-button
              v-else
              fill
              color="red"
              class="margin-horizontal"
              @click="cancelarGeneracion"
            >Cancelar generación</f7-button>
          </f7-page>
        </template>
      </r-form>
    </f7-popup>
    <!-- Aviso persistente mientras el job sigue vivo con el modal cerrado -->
    <div
      v-if="generacion && (generacionEnCurso || generacion.numErrores) && !popupCalcularShow"
      class="generacion-banner"
      @click="popupCalcularShow = true"
    >
      <span>{{generacion.texto}}</span>
      <span v-if="generacion.total > 0"> ({{generacion.hechos}}/{{generacion.total}})</span>
      <span v-if="generacion.guardados"> · {{generacion.guardados}} guardados</span>
      <span v-if="generacion.restanteTexto"> · ~{{generacion.restanteTexto}}</span>
    </div>
  </f7-page>
</template>
<style scoped>
.label-group {
  margin-top: 20px;
  margin-left: 20px;
  font-weight: bold;
}
.generacion-panel {
  margin-bottom: 12px;
}
.generacion-texto {
  font-weight: bold;
  margin-bottom: 6px;
}
.generacion-detalle {
  font-size: 12px;
  color: var(--f7-theme-color-gray, #888);
  margin-top: 4px;
}
.generacion-error {
  color: #d32f2f;
  font-weight: bold;
}
.generacion-errores {
  margin: 6px 0 0;
  padding-left: 18px;
  font-size: 12px;
  color: #d32f2f;
  max-height: 140px;
  overflow-y: auto;
}
.generacion-banner {
  position: fixed;
  bottom: 12px;
  right: 12px;
  z-index: 13000;
  max-width: 420px;
  padding: 10px 14px;
  border-radius: 6px;
  background: var(--f7-theme-color, #2196f3);
  color: #fff;
  font-size: 13px;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}
</style>
<style>
.aurora .f7-icons,
.aurora .material-icons {
  font-size: 16px;
}
</style>
<script>
import rDynamicList from "../../components/rDynamicList.vue";
import ListadoCalendario from "../../js/db/ListadoCalendario.js";
import ListadoCalendarioEvents from "../../js/db/ListadoCalendarioEvents.js";
import Empleado from "../../js/db/Empleado.js";
import Utils from "../../js/Utils.js";
import DateUtils from "../../js/DateUtils.js";
import { EventBus } from "../../js/EventBus.js";
import rInput from "./../../components/rInput.vue";
import rForm from "./../../components/rForm.vue";
import rAutocomplete from "./../../components/rAutocomplete.vue";
import RAutocompleteM2m from '../../components/rAutocompleteM2m.vue';
import rFiles from "./../../components/rFiles.vue";
import Documento from "./../../js/db/Documento.js";
import preloaderDeLaSesion from "./../../js/utils/preloaderDeLaSesion.js";

export default {
  components: {
    rDynamicList,
    rInput,
    rForm,
    rAutocomplete,
    RAutocompleteM2m,
    rFiles
  },
  data() {
    return {
      ListadoCalendario,
      Empleado,
      codigoListadoCalendario: null,
      Utils,
      Documento,
      DateUtils,
      popupCalcularShow: false,
      filter: null,
      // Último evento SSE de la generación de resúmenes ({texto, hechos, total, restanteTexto, estado})
      generacion: null,
      // Id de la ejecución que estamos siguiendo, para ignorar eventos de tiradas anteriores
      runIdGeneracion: null
    };
  },
  props: {
    tipoLinea: {
      type: String
    }
  },
  computed: {
    generacionEnCurso: function () {
      return !!this.generacion && this.generacion.estado === 'progreso';
    },
    progresoPorcentaje: function () {
      const g = this.generacion;
      if (!g || !g.total) return 0;
      return Math.round((g.hechos / g.total) * 100);
    }
  },
  methods: {
    filterColumns: function (columns) {
      const self = this;
      if (self.tipoLinea == 'DIA') {
        columns = columns.filter(column => {
          return column.pathName != 'totalConsumoReal';
        });
      } else if (self.tipoLinea == 'SEMANA') {
        columns = columns.filter(column => {
          return column.pathName != 'dia' && column.pathName != 'totalConsumoReal';
        });
      } else if(self.tipoLinea == 'MES') {
        columns = columns.filter(column => {
          return column.pathName != 'dia' && column.pathName != 'semana';
        });
      }
      return columns;
    },
    filasSeleccionadas: function () {
      let filas = [...Object.values(this.$refs.rlist.selected)].map(selected => {
        return { id: selected.id };
      });
      return filas;
    },
    reload: function () {
      if (this.$refs.rlist) {
        this.$refs.rlist.reload();
      }
    },
    getMeses: function () {
      const self = this;
      return [
        {id: 1, nombre: "01 - " + self.$t('Enero')},
        {id: 2, nombre: "02 - " + self.$t('Febrero')},
        {id: 3, nombre: "03 - " + self.$t('Marzo')},
        {id: 4, nombre: "04 - " + self.$t('Abril')},
        {id: 5, nombre: "05 - " + self.$t('Mayo')},
        {id: 6, nombre: "06 - " + self.$t('Junio')},
        {id: 7, nombre: "07 - " + self.$t('Julio')},
        {id: 8, nombre: "08 - " + self.$t('Agosto')},
        {id: 9, nombre: "09 - " + self.$t('Septiembre')},
        {id: 10, nombre: "10 - " + self.$t('Octubre')},
        {id: 11, nombre: "11 - " + self.$t('Noviembre')},
        {id: 12, nombre: "12 - " + self.$t('Diciembre')}
      ];
    },
    popupCalcularResumen: function (tipoLinea) {
      const self = this;
      const app = self.$f7;
      
      // Obtener el filtro del r-dynamic-list
      let filterFromList = {};
      if (self.$refs.rlist && self.$refs.rlist.getFilterData()) {
        // Copiar el filtro actual del listado
        filterFromList = Object.assign({}, self.$refs.rlist.getFilterData());
      }
      
      // Crear el filter con tipoLinea indicado y datos del filtro del listado
      let fecha = new Date();
      self.filter = {
        tipoLinea: tipoLinea,
        anio: filterFromList.anio || fecha.getFullYear(),
        meses: filterFromList.mes ? filterFromList.mes : [(fecha.getMonth() + 1)]
      };
      
      // Si tipoLinea es DIA o SEMANA, agregar semana si existe en el filtro
      if (['SEMANA', 'DIA'].includes(tipoLinea)) {
        self.filter.semana = filterFromList.semana || null;
      }
      
      // Si tipoLinea es DIA, agregar dia si existe en el filtro
      if (tipoLinea === 'DIA') {
        self.filter.dia = filterFromList.dia || null;
      }
      
      // Copiar otros campos del filtro que puedan ser relevantes
      if (filterFromList.username) {
        self.filter.usernames = filterFromList.username;
      }
      
      self.popupCalcularShow = true;
    },
    calcular: function (item) {
      const self = this;
      const app = self.$f7;
      // #663 · La espera de la sesión: si la sesión cambia en vuelo, la frontera calla el `finally`
      // que la apagaba.
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      ListadoCalendario.calcular({data: item})
        .then(() => {
          if (self.$refs.popupcalcular) {
            self.$refs.popupcalcular.close();
          }
          self.reload();
        })
        .catch((err) => {
          const msg = (err && (err.message || err.response?.data?.message || err.response?.data?.cause)) || 'Error al calcular el resumen';
          app.dialog.alert(msg, 'Error');
        })
        .finally(() => {
          espera.cerrar();
        });
    },
    // Generación masiva: se lanza en el servidor y se sigue por SSE, así que cerrar el modal
    // (o irse a otra pantalla) no corta el proceso ni la narración del progreso.
    lanzarGeneracion: function (item) {
      const self = this;
      const app = self.$f7;
      self.generacion = null;
      ListadoCalendario.lanzarCalculo({data: item})
        .then((res) => {
          const r = (res && res.data) || res || {};
          // Nos quedamos con el id de ESTA ejecución antes de escuchar: así descartamos los
          // eventos reproducidos de tiradas anteriores (ver onEventoGeneracion).
          self.runIdGeneracion = r.runId || null;
          // Suscribirse DESPUÉS del POST, no antes: al acabar un job cerramos el stream, y
          // reabrirlo antes de lanzar hacía que el 'fin' viejo reproducido lo cerrase de nuevo
          // al instante. subscribe() es idempotente.
          ListadoCalendarioEvents.subscribe(self.onEventoGeneracion, self.$f7);
          if (r.lanzado === false && r.enCurso) {
            app.dialog.alert('Ya hay una generación de resúmenes en curso.', 'Aviso');
          }
        })
        .catch((err) => {
          const msg = (err && (err.message || err.response?.data?.message || err.response?.data?.cause)) || 'Error al lanzar la generación';
          app.dialog.alert(msg, 'Error');
        });
    },
    cancelarGeneracion: function () {
      ListadoCalendario.cancelarCalculo();
    },
    onEventoGeneracion: function (payload) {
      const self = this;
      if (!payload || payload.accion !== 'resumenCalendario') return;
      // Descartamos eventos de otra ejecución. El canal reenvía su último evento a quien se
      // conecta, así que sin esto el 'fin' de la tirada anterior se colaba como si fuera de
      // ésta y cerraba el stream recién abierto.
      if (self.runIdGeneracion && payload.runId && payload.runId !== self.runIdGeneracion) return;
      self.generacion = payload;
      if (payload.estado === 'progreso') {
        // Los resúmenes se guardan según se generan, así que refrescamos de vez en cuando
        // para que se vean aparecer (sin machacar el listado en cada evento).
        if (payload.hechos && payload.hechos % 10 === 0) self.reload();
        return;
      }
      // Job terminado. Del cierre del stream se encarga ListadoCalendarioEvents al ver el
      // evento terminal, que sigue vivo aunque esta pantalla ya no exista.
      self.reload();
      self.runIdGeneracion = null;
      if (!payload.numErrores) {
        // Sin errores no hay nada que leer: limpiamos el aviso solo. Con errores se queda
        // hasta que el usuario cierre, que para eso los queremos ver.
        setTimeout(() => {
          if (self.generacion && self.generacion.estado !== 'progreso') self.generacion = null;
        }, 8000);
      }
    },
    asignaConsumoReal: function (item) {
      // mostramos un dialog.prompt para que el usuario introduzca el consumo real
      this.$f7.dialog.prompt('Introducir el consumo real', 'Consumo Real', (value) => {
        item.totalConsumoReal = value.replace(',', '.');
        ListadoCalendario.asignaConsumoReal({data: item}).then(() => {
          this.reload();
        });
      });
    },

    onImport: function (res) {
      var self = this;
      var app = self.$f7;
      self.ListadoCalendario.importar(res.documento).then((res) => {
        self.$set(self.$refs.rformImport.formData,'documento',[]);
        self.$refs.rlist.submitFilterForm();
        app.preloader.hide();
      }).finall;
    },
    onImportError: function (e) {
      var self = this;
      var app = self.$f7;
      app.preloader.hide(); 
      // TODO mensaje error;
    },
    beforeSaveImport: function(data, resolve, reject) {
      var self = this;
      var app = self.$f7;
      var o = Object.assign({}, data);
      o.documento = Array.isArray(o.documento) ? o.documento[0] : o.documento;
      app.preloader.hide();
      resolve(o);
    },
    loadFile: function () {
      var self = this;
      var app = self.$f7;
      self.$refs.rformImport.saveItem();
      app.preloader.show();
    }
  },
  mounted: function () {
    const self = this;
    EventBus.$on("listadocalendarioGuardado", self.reload);
    // Preguntamos primero si hay algo en marcha (lanzado antes de entrar aquí o desde otra
    // pestaña) y solo entonces nos enganchamos al canal. Suscribirse a ciegas gastaba una de las
    // pocas conexiones SSE por host aunque no hubiera nada que escuchar.
    ListadoCalendario.estadoCalculo().then((res) => {
      const r = (res && res.data) || res || {};
      if (!r.enCurso) return;
      self.runIdGeneracion = r.runId || null;
      if (r.ultimoEvento) self.generacion = r.ultimoEvento;
      ListadoCalendarioEvents.subscribe(self.onEventoGeneracion, self.$f7);
    }).catch(() => {});
  },
  beforeDestroy: function () {
    const self = this;
    EventBus.$off("listadocalendarioGuardado", self.reload);
    ListadoCalendarioEvents.unsubscribe(self.onEventoGeneracion);
  }
};
</script>
